// utils/offlineFetchCertifications.js
import axios from "axios";
import { db } from "./offlineDB";
import { env } from "../constants/env";

export const fetchCertificationSummary = async ({
  labId,
  name,
  section,
  token,
}) => {
  try {
    // 1️⃣ Try local data first
    const localData = await db.offlineCertifications
      .where("[labId+section]")
      .equals([labId, section])
      .toArray();

    if (!navigator.onLine) {
      if (localData.length) {
        console.log(`[Offline Fetch] Returning local data for ${section}`);
        return localData.map((item) => ({
          id: item.id,
          title: `${name} - ${section}`,
          totalScore: item.totalScore,
          created: new Date(
            item.createdAt || item.timestamp
          ).toLocaleDateString(),
          updated: new Date(
            item.updatedAt || item.timestamp
          ).toLocaleDateString(),
          status: item.status,
        }));
      } else {
        console.warn(`[Offline Fetch] No offline data for ${section}`);
        return [];
      }
    }

    // 2️⃣ Online → fetch from API
    const res = await axios.get(`${env.kataApiUrl}/api/certification/summary`, {
      params: { labId, name, section },
      headers: { Authorization: `Bearer ${token}` },
    });

    const formatted = res.data.map((item) => ({
      id: item._id,
      title: `${name} - ${section}`,
      totalScore: item.totalScore,
      created: new Date(item.createdAt).toLocaleDateString(),
      updated: new Date(item.updatedAt).toLocaleDateString(),
      status: item.status,
    }));

    // Save online data to IndexedDB
    for (const item of res.data) {
      const existing = await db.offlineCertifications.get(item._id);

      // 🔐 Protect unsynced local edits
      if (existing?.offline) {
        console.log(
          "[Offline Fetch] Skipping overwrite – local offline edits exist",
          item._id
        );
        continue;
      }

      const offlineId =
        item._id && typeof item._id === "string"
          ? item._id
          : `offline-${crypto.randomUUID()}`;

      await db.offlineCertifications.put({
        ...(existing ?? {}),
        id: offlineId,
        labId,
        section,
        status: item.status,
        totalScore: item.totalScore,
        createdAt: item.createdAt,
        updatedAt: item.updatedAt,
        offline: false,
        lastSynced: new Date().toISOString(),
      });
    }

    return formatted;
  } catch (err) {
    console.error(`[Offline Fetch] Failed for ${section}:`, err.message);
    return [];
  }
};
